import { DatosAspiranteModel } from './datos-aspirante.model';

export class ValidarAspiranteResponseModel {

    EsCliente?: boolean;
    DatosAspirante?: DatosAspiranteModel;

    clear() {
        this.EsCliente = false;
        this.DatosAspirante = new DatosAspiranteModel();
    }
}
